import { ActionIcon, Tooltip } from '@mantine/core';
import { Icon, variants } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { canOpenPanelQuickReplacement } from 'app/modules/wallforming/components/scenes/tools/quick-panel-replacement/utils/quickPanelReplacementUtils';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

interface ArticleToolsProps {
    menuOpened: boolean;
}

const screenWidth = window.screen.width;

export const ArticleTools = ({ menuOpened }: ArticleToolsProps) => {
    const { t } = useTranslation();
    const {
        articleInstanceSelectionsCount,
        arePivotControlsActive,
        updatePivotControls,
        isPanelQuickReplacementOpen,
        setIsPanelQuickReplacementOpen,
        canQuickReplace
    } = usePlacementStore(
        useShallow((state) => {
            const articleInstanceSelectionsCount = Object.keys(state.articleInstanceSelections).length;
            return {
                articleInstanceSelectionsCount,
                arePivotControlsActive: state.arePivotControlsActive,
                updatePivotControls: state.updatePivotControls,
                isPanelQuickReplacementOpen: state.isPanelQuickReplacementOpen,
                setIsPanelQuickReplacementOpen: state.setIsPanelQuickReplacementOpen,
                canQuickReplace: canOpenPanelQuickReplacement(state)
            };
        })
    );
    return (
        <>
            <Tooltip disabled={menuOpened} label={t('transform')} position="right" variant={variants.tooltip.right}>
                <ActionIcon
                    aria-label={t('transform')}
                    aria-pressed={arePivotControlsActive}
                    className={`
                        bg-background-gray-ultra-light hover:bg-background-gray! pointer-events-auto
                        ${screenWidth >= 1920 ? 'action-icon-large' : 'action-icon-medium'}
                    `}
                    opacity={articleInstanceSelectionsCount >= 1 ? 1 : 0.6}
                    style={{ cursor: articleInstanceSelectionsCount >= 1 ? 'pointer' : 'not-allowed' }}
                    variant={arePivotControlsActive ? variants.actionIcon.activated : undefined}
                    onPointerDown={updatePivotControls}
                >
                    transform
                </ActionIcon>
            </Tooltip>
            <Tooltip
                disabled={menuOpened}
                label={t('labelInputActionPanelQuickReplacement')}
                position="right"
                variant={variants.tooltip.right}
            >
                <ActionIcon
                    aria-label={t('labelInputActionPanelQuickReplacement')}
                    aria-pressed={isPanelQuickReplacementOpen}
                    className={`
                        bg-background-gray-ultra-light hover:bg-background-gray! pointer-events-auto
                        ${screenWidth >= 1920 ? 'action-icon-large' : 'action-icon-medium'}
                    `}
                    disabled={!canQuickReplace && !isPanelQuickReplacementOpen}
                    opacity={canQuickReplace || isPanelQuickReplacementOpen ? 1 : 0.6}
                    style={{
                        cursor: canQuickReplace || isPanelQuickReplacementOpen ? 'pointer' : 'not-allowed'
                    }}
                    variant={isPanelQuickReplacementOpen ? variants.actionIcon.activated : undefined}
                    onClick={() => {
                        if (isPanelQuickReplacementOpen) {
                            setIsPanelQuickReplacementOpen(false);
                        } else if (canQuickReplace) {
                            setIsPanelQuickReplacementOpen(true);
                        }
                    }}
                >
                    <Icon aria-hidden="true" icon="change_circle" size="xl" />
                </ActionIcon>
            </Tooltip>
        </>
    );
};